/**
 * Lead-source metadata is a free-form JSON object. Values were always strings
 * until the website tracker (2026-09) started sending a nested `tracker`
 * object. React throws on an object child, so every metadata value passes
 * through here before it reaches JSX.
 */
export const formatMetadataValue = (value) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'number' || typeof value === 'boolean') return String(value);
    if (Array.isArray(value)) return value.map((v) => formatMetadataValue(v)).join(', ');
    try {
        return JSON.stringify(value);
    } catch (e) {
        return String(value);
    }
};

const isPlainObject = (v) => v !== null && typeof v === 'object' && !Array.isArray(v);

/**
 * `{ key, value }` rows for a metadata table. One level of nested objects is
 * flattened to dotted keys (`tracker.visitor_id`); deeper values are
 * stringified. Blank strings are dropped, matching the previous behaviour.
 */
export const flattenMetadataEntries = (metadata) => {
    if (!isPlainObject(metadata)) return [];
    const rows = [];
    Object.entries(metadata).forEach(([key, value]) => {
        if (isPlainObject(value)) {
            Object.entries(value).forEach(([innerKey, innerValue]) => {
                const text = formatMetadataValue(innerValue);
                if (text !== '') rows.push({ key: `${key}.${innerKey}`, value: text });
            });
            return;
        }
        const text = formatMetadataValue(value);
        if (text !== '') rows.push({ key, value: text });
    });
    return rows;
};
